module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZpnx9fmRs8wwcJ////+sxtlLg6yDqcbI2ebW4uxZjLPj7PI+eaaevNK6z99nlrl1n7+QpaS7AAAAB3RSTlMAYL8AIM/vi50ITwAAAP1JREFUeF7t2Elug0AUhGFG1xua0UPuf9NgRVZbkb2AV4vE6v8A36JRg6jqXt0gUFO3W1Xbdj2C9d0d6k4Id+o2qAehvq1qUKqrBpSaCqQK9KICnZP/SiYd9kNn8Veto+2Ekr9pve2D/H2JBXliQZ5YkH+xILEDkP40ybOkB6AHbeq5NQABg+eGCIQxQxqCkM/pGoPyxZlikH4uNJMOeyA9fpsztASgZ0dwFFqWi3hOaa8REjSCA13BgWbjQMnAgGQECJCoIQ5NlxtyoUuL/w0VqED25yAIC9KHk0JQ/oiJBSFAV3dJ9tE/fgWijSy02Yc1RNGmMeZYt8WYD78Ba2ybzMRJCooAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f17f.png
// module id = 574
// module chunks = 0